import { render, staticRenderFns } from "./About.vue?vue&type=template&id=a2f56152&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=a2f56152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f56152",
  null
  
)

export default component.exports